import * as React from "react";
import { LinkView } from "./LinkView";
import { GifLoader } from "../gif-loader/GifLoader";
import { Accordion } from "./Accordion";
import { fetchPanelApi } from "static-content/view/api";
import { Talktext, RightBubbleWrapper, LeftBubbleWrapper, Video, TypingBubble, LeftBubbleText } from "./BubbleStyles";

export const RightBubble = (message, index, actions) => {
  let { type, payload, alternativeText } = message;
  let view = getView(type, payload);
  return (
    <RightBubbleWrapper key={index}>
      <Talktext className="rightBubble">{view}</Talktext>
    </RightBubbleWrapper>
  );
};

const getView = (type, payload) => {
  if (["button-gif", "gif"].includes(type))
    return <GifLoader src={payload} alternative={alternativeText} onClickImage={actions.clickImage} />;
  else if (type === "link") {
    const split = payload.split("@@");
    return split.length > 1 ? split[1] : "";
  }
  return payload;
};

export const LeftBubble = (message, withLogo, index, bubbleAnimationPosition, actions, appMode) => {
  let { type, payload, tag, key, alternativeText } = message;
  let isAnimated = bubbleAnimationPosition !== null;
  let animatedClass = isAnimated ? " animated" : "";
  let answerSpeed = -3;
  let totalMessageWait = bubbleAnimationPosition + answerSpeed;
  const tagClass = tag.length > 0 ? tag[0].code : "";
  return (
    <LeftBubbleWrapper
      className={`${getClassNameForLeftBubble(withLogo, type)} ${animatedClass}`}
      key={key}
      wait={isAnimated ? totalMessageWait : null}
    >
      {isAnimated && <TypingBubble duration={isAnimated ? totalMessageWait + 1 : null} />}
      <LeftBubbleText
        className={`${animatedClass} ${type} ${appMode} ${tagClass}`}
        wait={isAnimated ? totalMessageWait + 1.5 : null}
      >
        {getBubbleContent(type, payload, tag, index, actions, alternativeText)}
      </LeftBubbleText>
    </LeftBubbleWrapper>
  );
};

const getBubbleContent = (type, payload, tag, index, actions, alternative) => {
  switch (type) {
    case "text":
      return payload;
    case "accordion":
      const panel = fetchPanelApi(payload);
      return <Accordion heading={panel.get("heading")} body={panel.get("body")} />;
    case "gif":
      return (
        <GifLoader
          src={payload}
          alternative={alternative}
          enlarge={toEnlarge(payload)}
          onClickImage={actions.clickImage}
        />
      );
    case "link":
      return <LinkView payload={payload} tag={tag} index={index} onClickInvestButton={actions.onClickInvestButton} />;
    case "youtube":
      return YoutubeView(payload);
    default:
      return <React.Fragment />;
  }
};

const getClassNameForLeftBubble = (withLogo, type) => {
  let logoClass = withLogo ? "with-logo" : "without-logo";
  if (type === "gif" || type === "youtube") return logoClass;
  return `${logoClass}`;
};

const toEnlarge = (url) => {
  let enlargeExtensions = ["jpg", "jpeg", "png"];
  let splitUrl = url.split(".");
  let extension = splitUrl[splitUrl.length - 1].toLowerCase();
  return enlargeExtensions.indexOf(extension) >= 0;
};

export const YoutubeView = (link) => {
  return (
    <Video className="youtube-video">
      <iframe
        src={YOUTUBE_EMBED_PREFIX + link}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </Video>
  );
};

export const YOUTUBE_EMBED_PREFIX = "https://www.youtube.com/embed/";
